const faqcategory = {
    getlist: 'faqcategory/getlist',
    add: 'faqcategory/add',
    update: 'faqcategory/update',
    remove: 'faqcategory/remove',
    get: 'faqcategory/get',
    getall: 'faqcategory/getall-by-admin',
    clearcache: 'faqcategory/clear-cache',
}
export default faqcategory